import { Map, is } from "immutable";

export const BaseSuggestedResponse = action => Map({
  target: action.responseIdToAdd,
  label: ""
});

/**
 * @param {Immutable.List} messages
 * @param {String} messageId
 * @returns {Number}
 */
export function getMessageIndex(messages, messageId) {
  return messages.findIndex(m => m.id === messageId);
}

/**
 *
 * @param {String} responseId
 * @param {Map} state
 */
export function validateResponse(responseId, state) {
  const response = state.get(responseId);
  const languagesArray = response.messages.keySeq().toArray();

  /** Return invalid if no languages */
  if (!languagesArray.length) {
    return false;
  }

  if (!response.handle) {
    return false;
  }

  return languagesArray.every((key) => {
    const messages = response.getIn(["messages", key]);

    return messages.every(m => !m.invalidFields.size);
  });
}

/**
 * @param {Record} responseRecord
 * @returns {Record}
 */
function removeStateFields(responseRecord) {
  let responseRecordToCompare = responseRecord;
  const stateFields = [
    "isDirty",
    "isValid"
  ];
  stateFields.forEach((field) => {
    responseRecordToCompare = responseRecordToCompare.delete(field);
  });

  return responseRecordToCompare;
}

/**
 * Returns true if and only if the response has changed since the last save
 * @param {String} responseId
 * @param {Map} lastSavedResponsesState
 * @param {Map} currentResponsesState
 * @returns {Boolean}
 */
export function checkIfDirty(
  responseId,
  lastSavedResponsesState = Map(),
  currentResponsesState
) {
  const lastSavedResponse = lastSavedResponsesState.get(responseId);
  const currentResponse = currentResponsesState.get(responseId);

  if (lastSavedResponse && currentResponse) {
    return !is(
      removeStateFields(lastSavedResponse),
      removeStateFields(currentResponse)
    );
  }

  return true;
}

/**
 * @param {String} responseId
 * @param {Map} lastSavedResponsesState
 * @param {Map} state
 * @returns {Map}
 */
export function stateWithMetaData(
  responseId,
  lastSavedResponsesState,
  state
) {
  return state.mergeIn([responseId], {
    isDirty: checkIfDirty(
      responseId,
      lastSavedResponsesState,
      state
    ),
    isValid: validateResponse(responseId, state)
  });
}
